import { useBrand } from '@bnnvara/brand';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';
import { PublicationCard } from '../../components/cards/PublicationCard';
import { getBrandSlug } from '../../helpers/getBrandSlug';

const ComposableVideoCard = (props) => {
  const brand = useBrand();
  const { id, subThemes, image } = props;

  return (
    <GridItem
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 3"
      columnEndXl="span 3"
      key={id}
    >
      <PublicationCard
        url={`${getBrandSlug(brand.slug)}/videos/${id}`}
        page="Homepage"
        subTheme={subThemes[0]}
        isThemePage
        brand={brand}
        thumbnail={image}
        id={id}
        {...props}
      />
    </GridItem>
  );
};

ComposableVideoCard.propTypes = {
  id: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string,
    altText: PropTypes.string,
  }),
  subThemes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      slug: PropTypes.string,
      color: PropTypes.string,
      colorHover: PropTypes.string,
      colorActive: PropTypes.string,
      colorVisited: PropTypes.string,
      backgroundImageUrl: PropTypes.string,
      backgroundImageMobileUrl: PropTypes.string,
      parentSlug: PropTypes.string,
      parent: {
        id: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        slug: PropTypes.string,
        color: PropTypes.string,
        colorHover: PropTypes.string,
        colorActive: PropTypes.string,
        colorVisited: PropTypes.string,
        backgroundImageUrl: PropTypes.string,
        backgroundImageMobileUrl: PropTypes.string,
      },
    })
  ),
};

export default ComposableVideoCard;
